import _regeneratorRuntime from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import pdfjs from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

var getRealXY = function getRealXY(transformMatrix, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      x = _ref2[0],
      y = _ref2[1];

  var a = transformMatrix.a,
      b = transformMatrix.b,
      c = transformMatrix.c,
      d = transformMatrix.d,
      e = transformMatrix.e,
      f = transformMatrix.f; // Apply the transformation to input coordinates using matrix dot product formula
  //
  // | a c e |   | x |    |x * a + y * c + 1 * e |
  // | b d f | * | y |  = |x * b + y * d + 1 * f |
  // | 0 0 1 |   | 1 |    |x * 0 + y * 0 + 1 * 1 |

  return [x * a + y * c + 1 * e, x * b + y * d + 1 * f];
};
/**
 * fillTextIntercept modified a canvas context object to intercept all calls to 'fillText' and recorder results into an array
 * Inspired by: https://www.garysieling.com/blog/extracting-tables-from-pdfs-in-javascript-with-pdf-js
 * @param {CanvasRenderingContext2D} ctx canvas context to intercept calls on.
 * @param {Object} storageObject store all found characters in the 'chars' property on this object.
 */


function fillTextIntercept(ctx, storageObject, charCodeOffset) {
  // Add chars array to storageObject
  if (storageObject.chars) throw new Error("fillTextIntercept attempted to override '.chars' on storageObject: ".concat(storageObject)); // eslint-disable-next-line no-param-reassign

  storageObject.chars = []; // Save reference to the real fillText function

  var fillText = ctx.fillText;

  ctx.fillText = function intercept(text, x, y) {
    var realChar = charCodeOffset ? String.fromCharCode(text.charCodeAt(0) - charCodeOffset) : text;
    var transformMatrix = ctx.getTransform();

    var _getRealXY = getRealXY(transformMatrix, [x, y]),
        _getRealXY2 = _slicedToArray(_getRealXY, 2),
        realX = _getRealXY2[0],
        realY = _getRealXY2[1];

    var width = ctx.measureText(realChar).width * transformMatrix.a; // Store Character info in chars array

    /* 
      Probably should be using some type of callback storage solution.
      For now I am just adding a storageProperty to the page object
    */
    // eslint-disable-next-line no-param-reassign

    storageObject.chars[storageObject.chars.length] = {
      charCode: text.charCodeAt(0),
      text: realChar,
      x: realX,
      y: realY,
      width: width
    }; // Call real filltext function

    fillText.apply(ctx, [text, x, y]);
  };
}

var addCanvasAndRender = function addCanvasAndRender(charCodeOffset) {
  return function (page) {
    var scale = 1.5;
    var viewport = page.getViewport({
      scale: scale
    }); // Prepare canvas using PDF page dimensions

    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    canvas.height = viewport.height;
    canvas.width = viewport.width; // Replace context fillText method  with function to store text info on page obj.

    fillTextIntercept(context, page, charCodeOffset); // Render PDF page into canvas context

    var renderContext = {
      canvasContext: context,
      viewport: viewport
    };
    return new Promise(function (resolve) {
      page.render(renderContext).promise.then(function () {
        resolve(page);
      });
    });
  };
};

var pdfText = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(src, charCodeOffset) {
    var loadingTask, pdf, pagesToRender, renderingPages, renderedPages, pageCharacters;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            loadingTask = pdfjs.getDocument(src);
            _context.next = 3;
            return loadingTask.promise;

          case 3:
            pdf = _context.sent;
            pagesToRender = new Array(pdf.numPages).fill(null);
            renderingPages = pagesToRender.map(function (_, i) {
              return pdf.getPage(i + 1).then(addCanvasAndRender(charCodeOffset));
            });
            _context.next = 8;
            return Promise.all(renderingPages);

          case 8:
            renderedPages = _context.sent;
            pageCharacters = renderedPages.map(function (page) {
              return page.chars;
            });
            return _context.abrupt("return", {
              pages: pageCharacters,
              numPages: pdf.numPages
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function pdfText(_x, _x2) {
    return _ref3.apply(this, arguments);
  };
}();

export default pdfText;